import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpKeyRefresh implements ICommand
{

	public Key : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Key = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeString(this.Key);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpKeyRefresh();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Key(S)='+this.Key+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50047;
	}

	public getCmdName() : string
	{
		return 'SpKeyRefresh';
	}

}
